import { Component, OnInit } from '@angular/core';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { ILogin } from 'src/app/models/ILogin';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  userName : string;
  forget:boolean = false;
  password: string;
  loading:boolean = false;
  _errorMessage:string=''; 
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
   //this.alert.error(this._errorMessage);
  }
  constructor( private httphelper:HttphelperService , private router:Router,private messageService: MessageService,private translate: TranslateService) { }

  ngOnInit(): void {
  }
  forgetPassword():void{
    this.forget = true;
  }  
  login():void
  {
    if(this.userName == "" || this.userName == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'warning', detail:"Please Enter User Name", life: 2000});
      //this.alert.warn("Please Enter User Name");
      return;
    }
    if(this.password == "" || this.password == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'warning', detail:"Please Enter Password", life: 2000});
     // this.alert.warn("Please Enter Password");
      return;
    }
    let url = 'api/Account/MobileLogin';
    let model :ILogin  =  {UserName : this.userName , Password : this.password , IsDoctor : false , FirebaseToken:""};
    this.loading = true;
    this.httphelper.postRequest(url,false,model).subscribe(
      {
        next:data => {
           if(data.Success)
           {
             if(data.Data.token == null || data.Data.token == undefined)
             {
               this.errorMessage = "This User Is Not Active";
                return;
             }
             localStorage.setItem('token',data.Data.token);
             localStorage.setItem('patientName',data.Data.FullName);
             localStorage.setItem('gender',data.Data.GenderId);
             localStorage.setItem('PatientId',data.Data.PatientId);
             localStorage.setItem('Image',data.Data.Image);
             localStorage.setItem('lang',"en");
             if(data.Data.LanguageId == 1){
              localStorage.setItem('lang',"ar");
             }
             //this.translate.use(localStorage.getItem('lang'));
             window.location.href = 'schedule';//.reload();
             //this.router.navigate(['/history']);
             //this.loading = false;
           }
           else
           {
              this.errorMessage = data.Message;
           }
           this.loading = false;
        },
        error:err => {this.errorMessage = "Error While Processing Data"     ;this.loading = false;}
      }
    );
  }
  register():void{
    window.location.href = 'register';
  }
}
